<template>
    <jet-dialog-modal @close="close" :show="true">
        <template #title>
            {{ notification.title }}
        </template>

        <template #content>
            <div v-html="notificationText">
            </div>
        </template>

        <template #footer>
            <jet-secondary-button @click.native="close" >
                Acknowledge
            </jet-secondary-button>
        </template>
    </jet-dialog-modal>

</template>


<script>
import JetDialogModal from '../../Jetstream/DialogModal';
import JetSecondaryButton from '../../Jetstream/SecondaryButton';

export default {
    name: 'NotificationModal',
    props: ['notification'],
    emits: ['close'],
    components: {
        JetDialogModal,
        JetSecondaryButton,
    },
    computed: {
        notificationText() {
            return this.notification.message.replaceAll("\n", "<br />").replaceAll("\\n", "<br />");
        }
    },  
    methods: {
        close() {
            axios.post('/notifications/' + this.notification.id + '/read');
            this.$emit('close');
        }
    }

}
</script>